import { css } from 'lit';

export const quantityDetailsStyles = css`
  :host {
    width: 100%;
  }

  details,
  .in-option {
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
    font-size: 0.875rem;
    width: 100%;
  }

  details summary div,
  .in-option {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }
`;
